module.exports = __webpack_public_path__ + "img/eye-gray.0ba5106e.svg";